import {
  STORE_FAVOURITE_MERCHANT_LIST,
  STORE_ISFORCE_TO_SIGN_OUT,
  STORE_HardReleaseVersion,
  STORE_CartCheckoutData,
  STORE_CustomerDefaultAddress,
  STORE_CustomerName,
  STORE_Division_details,
  STORE_DeliveryZoneID,
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_CSID,
  STORE_NIC,
  STORE_PhoneNo,
  STORE_PROMO_DATA,
  STORE_PROMOTIONS,
  STORE_RATING_POSID,
  STORE_Addons,
  STORE_Cart,
  STORE_SHEDULEDateNTime,
  STORE_MERCHANT,
  STORE_SelectedMerchant,
  STORE_SelectedMerchantProduct,
  STORE_dtoCustomerAddressList,
  SECRET_KEY,
  STORE_CSP,
  ENTRY_MODE,
  MID,
  TABLE_NO,
  STORE_INVALID_QR,
} from "../../database/store-names";
import {
  api_checkAppStoreVersion,
  api_LoadMerchantForMID,
  api_checkbuildversion,
  api_StartupPageLoad,
  api_LoadDevisons,
} from "../../connection/api/api-home";
import {
  SET_ZONE_DESCRIPTION_HOME_SCREEN,
  ENCRYPT_STORAGE,
  SET_STARTUP,
  BuildVersion,
  currentver,
} from "../../config/config";
import {
  set_dto_StartupPageLoadInfo,
  set_dto_Merchant,
} from "../../classes/dto-setters/dto-setter";
import { api_UpdateExpoPushToken } from "../../connection/api/api-profile";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { dto_Customer, dto_CustomerAddress } from "../../classes/dto-customer";
import { get_Href_URL_Params } from "../../functions/funtion";
import { PT_HOME, PT_LAND } from "../../routes/stack/paths/pt-home";
import { SET_UPDATE_URL } from "../../util/update-config";
import { VALIDATE_CSP } from "../../config/csp";
import { dto_Merchant } from "../../classes/dto-merchant";
import { ToastMessage } from "../../components/toast-notification/toast";
import { SET_COLORS } from "../../util/color-config";
import { dto_common } from "../../classes/dto-common";
import { CHECK_NIC } from "../../functions/common-screen-functions";
import { Update } from "../../util/updateUrl";
import { isMobile } from "react-device-detect";
import React from "react";

const SOFT_RELEASE_RELOAD_KEY = "SoftReleaseReloadedOnce";
const UPDATING_MEMORY_RETRY_MS = 60 * 1000;
const QR_ENTRY_RESET_MARKER = "QR_ENTRY_RESET_MARKER";

export default class Startup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CSP: "",
      startupErrorMessage: "",
      showQrStartupError: false,
    };
    this.updatingMemoryRetryTimer = null;
  }

  componentWillUnmount() {
    if (this.updatingMemoryRetryTimer) {
      window.clearTimeout(this.updatingMemoryRetryTimer);
      this.updatingMemoryRetryTimer = null;
    }
  }

  scheduleUpdatingMemoryRetry = (retryFn) => {
    if (this.updatingMemoryRetryTimer) {
      window.clearTimeout(this.updatingMemoryRetryTimer);
    }

    this.updatingMemoryRetryTimer = window.setTimeout(async () => {
      this.updatingMemoryRetryTimer = null;
      try {
        await retryFn();
      } catch (error) {
        console.error("Updating Memory retry failed:", error);
      }
    }, UPDATING_MEMORY_RETRY_MS);
  };

  parseResponseSafely = (response) => {
    if (response === undefined || response === null || response === "") {
      return null;
    }

    if (typeof response === "string") {
      return JSON.parse(response);
    }

    return response;
  };

  showStartupError = async (message, { showOverlay = false } = {}) => {
    const normalizedMessage =
      String(message || "").trim() ||
      "Something went wrong while loading the app. Please try again.";

    this.setState({
      startupErrorMessage: normalizedMessage,
      showQrStartupError: showOverlay,
    });
    await ToastMessage(1, normalizedMessage);
  };

  getResponseResult = (response) => {
    if (response && typeof response === "object") {
      return response.Result;
    }

    if (typeof response !== "string") {
      return undefined;
    }

    const trimmedResponse = response.trim();
    if (trimmedResponse === "Updating Memory") {
      return trimmedResponse;
    }

    try {
      return JSON.parse(trimmedResponse)?.Result;
    } catch (_error) {
      return undefined;
    }
  };

  handleUpdatingMemoryResponse = async (response, retryFn) => {
    if (this.getResponseResult(response) !== "Updating Memory") {
      return false;
    }

    await ToastMessage(1, "Updating memory, please wait.");
    this.scheduleUpdatingMemoryRetry(retryFn);
    return true;
  };

  parseDirectQrSearch = (rawSearch = "") => {
    const normalizedSearch = String(rawSearch || "").trim();
    if (!normalizedSearch.includes("?QR?")) {
      return null;
    }

    const parts = normalizedSearch.replace(/^\?/, "").split("?");
    const [, entryMode, rawSecretKey, rawMid, rawTableNo] = parts;
    if (String(entryMode || "").toUpperCase() !== "QR") {
      return null;
    }

    let secretKey = String(rawSecretKey || "").trim();
    if (secretKey !== "") {
      try {
        const decodedSecret = window.atob(secretKey);
        if (decodedSecret) {
          secretKey = decodedSecret;
        }
      } catch (_error) {}
    }

    const mid = String(rawMid || "").trim();
    const tableNo = String(rawTableNo || "").trim();

    return {
      entryMode: "QR",
      secretKey,
      mid,
      tableNo,
    };
  };

  resetStateForDirectQrEntry = ({
    csp,
    rawSearch,
    hardReleaseVersion,
    qrParams,
  }) => {
    const preservedKeys = {
      [STORE_CSP]: csp,
      [STORE_HardReleaseVersion]: hardReleaseVersion,
      [ENTRY_MODE]: qrParams?.entryMode,
      [SECRET_KEY]: qrParams?.secretKey,
      [MID]: qrParams?.mid,
      [TABLE_NO]: qrParams?.tableNo,
    };

    ENCRYPT_STORAGE.removeMultipleItems([
      STORE_CSID,
      STORE_CustomerName,
      STORE_PhoneNo,
      STORE_CustomerDefaultAddress,
      STORE_dtoCustomerAddressList,
      STORE_DeliveryZoneID,
      STORE_NIC,
      STORE_ISFORCE_TO_SIGN_OUT,
      STORE_RATING_POSID,
      STORE_PROMO_DATA,
      STORE_PROMOTIONS,
      STORE_FAVOURITE_MERCHANT_LIST,
      STORE_Cart,
      STORE_Addons,
      STORE_CartCheckoutData,
      STORE_SHEDULEDateNTime,
      STORE_FinaleSelelctCartMerchantNZone,
      STORE_MERCHANT,
      STORE_SelectedMerchant,
      STORE_SelectedMerchantProduct,
      STORE_INVALID_QR,
      STORE_Division_details,
    ]);

    ENCRYPT_STORAGE.clear();

    Object.entries(preservedKeys).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        ENCRYPT_STORAGE.setItem(key, value);
      }
    });

    dto_Customer.CSID = 0;
    dto_Customer.CusName = "";
    dto_Customer.Email = "";
    dto_Customer.PhoneNo = "";
    dto_Customer.NIC = "";
    dto_Customer.PushToken = "";
    dto_Customer.DeviceInfo = "";

    dto_CustomerAddress.DefaultAdd1 = "";
    dto_CustomerAddress.DefaultAdd2 = "";
    dto_CustomerAddress.DefaultAdd3 = "";
    dto_CustomerAddress.AddressGuid = "";
    dto_CustomerAddress.PhoneNo = "";
    dto_CustomerAddress.Location = "0,0";

    dto_common.DeliveryZoneID = 0;
    dto_common.SCHEDULEDDATE = "";
    dto_common.SCHEDULEDTIME = "";
  };

  isInvalidQrMerchantResponse = (response) => {
    if (!response || typeof response !== "object") {
      return false;
    }

    let merchantInfo = [];
    try {
      merchantInfo = JSON.parse(response.MerchantInfo || "[]");
    } catch (_error) {
      merchantInfo = [];
    }

    return (
      Array.isArray(merchantInfo) &&
      merchantInfo.length === 0 &&
      response.dtoMerchantList === null
    );
  };

  loadAppStoreVersion = async () => {
    let data = await api_checkAppStoreVersion();
    if (
      await this.handleUpdatingMemoryResponse(data, async () => {
        await this.loadAppStoreVersion();
      })
    ) {
      return null;
    }

    return this.parseResponseSafely(data);
  };

  async componentDidMount() {
    try {
      this.setState({ startupErrorMessage: "", showQrStartupError: false });
      ENCRYPT_STORAGE.removeItem(STORE_CartCheckoutData);
      let { csp } = this.props.params;
      const storedEntryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
      const rawSearch = window.location.search || "";
      const isQrEntryMode =
        storedEntryMode === "QR" ||
        rawSearch.includes("?QR?") ||
        rawSearch.includes("&from=QR") ||
        rawSearch.includes("?from=QR") ||
        rawSearch.includes("&ENTRY_MODE=QR") ||
        rawSearch.includes("?=QR");
      if ((await VALIDATE_CSP(csp)) === true) {
        let HardReleaseVersion = get_Href_URL_Params().ver;
        if (
          HardReleaseVersion === undefined ||
          HardReleaseVersion === null ||
          HardReleaseVersion === "" ||
          HardReleaseVersion === "undefined"
        ) {
          HardReleaseVersion = ENCRYPT_STORAGE.getItem(
            STORE_HardReleaseVersion,
          );
        }
        ENCRYPT_STORAGE.setItem(STORE_CSP, csp.toUpperCase());
        if (
          HardReleaseVersion !== undefined &&
          HardReleaseVersion !== null &&
          HardReleaseVersion !== "" &&
          HardReleaseVersion !== "undefined"
        ) {
          ENCRYPT_STORAGE.setItem(STORE_HardReleaseVersion, HardReleaseVersion);
        }
        const isDirectQrUrl = rawSearch.includes("?QR?");
        const qrParams = this.parseDirectQrSearch(rawSearch);
        const qrResetMarker = `${csp.toUpperCase()}|${rawSearch}`;
        if (
          isDirectQrUrl &&
          window.sessionStorage.getItem(QR_ENTRY_RESET_MARKER) !== qrResetMarker
        ) {
          this.resetStateForDirectQrEntry({
            csp: csp.toUpperCase(),
            rawSearch,
            hardReleaseVersion: HardReleaseVersion,
            qrParams,
          });
          window.sessionStorage.setItem(QR_ENTRY_RESET_MARKER, qrResetMarker);
        } else if (!isDirectQrUrl) {
          window.sessionStorage.removeItem(QR_ENTRY_RESET_MARKER);
        }
        this.setState({ CSP: csp.toUpperCase() });
        await SET_STARTUP({ csp: csp, HardReleaseVersion: HardReleaseVersion });
        SET_COLORS({ CSP: csp.toUpperCase() });
        SET_UPDATE_URL({ CSP: csp });
        await CHECK_NIC();
        if (!isQrEntryMode) {
          let objVersion = await api_checkbuildversion();
          if (
            objVersion === undefined ||
            objVersion === null ||
            objVersion === ""
          ) {
            await ToastMessage(
              1,
              "Unable to connect to server. Please try again.",
            );
            return;
          }
          let CheckBuildVersion = JSON.parse(objVersion);
          if (CheckBuildVersion.Result === "UPDATE") {
            const alreadyReloaded =
              window.sessionStorage.getItem(SOFT_RELEASE_RELOAD_KEY) === "1";
            if (!alreadyReloaded) {
              window.sessionStorage.setItem(SOFT_RELEASE_RELOAD_KEY, "1");
              window.location.reload();
              return;
            }
            window.sessionStorage.removeItem(SOFT_RELEASE_RELOAD_KEY);
          }
          window.sessionStorage.removeItem(SOFT_RELEASE_RELOAD_KEY);
          if (CheckBuildVersion.Result === "Updating Memory") {
            await ToastMessage(
              1,
              "server Memory is being updated, Please re-open the app in few minutes",
            );

            return;
          }
        }
        let objData = await this.loadAppStoreVersion();
        if (!objData) {
          return;
        }
        if (objData.Result === "UPDATE") {
          let device = window.navigator.appVersion;
          if (device !== undefined) {
            if (device.toUpperCase().includes("ANDROID")) {
              window.location.href = Update.ANDROIDstoreURL;
            }
            if (device.toUpperCase().includes("IPHONE")) {
              window.location.href = Update.IOSstoreURL;
            }
            if (device.toUpperCase().includes("IPAD")) {
              window.location.href = Update.IOSstoreURL;
            }
          }
        } else {
          dto_common.MemmoryURl = objData;
          ENCRYPT_STORAGE.setItem("ar3Mad32u4faTSrAUla", objData);

          if (dto_common.MemmoryURl !== "") {
            let stup = await api_StartupPageLoad();
            let x = JSON.parse(stup);
            await set_dto_StartupPageLoadInfo(x);

            this.setState({ isReady: true });

            if (!isQrEntryMode) {
              let IsForcedToSignout = await api_UpdateExpoPushToken();
              let objIsForcedToSignout = JSON.parse(IsForcedToSignout);
              let objobjIsForcedToSignout = JSON.parse(objIsForcedToSignout);

              if (objobjIsForcedToSignout.length > 0) {
                ENCRYPT_STORAGE.setItem(
                  STORE_ISFORCE_TO_SIGN_OUT,
                  objobjIsForcedToSignout[0].IsForcedToSignout,
                );

                let PendingRatePOSID = objobjIsForcedToSignout[0].POSID;
                ENCRYPT_STORAGE.setItem(STORE_RATING_POSID, PendingRatePOSID);
              } else {
                ENCRYPT_STORAGE.setItem(STORE_ISFORCE_TO_SIGN_OUT, false);
              }
            } else {
              ENCRYPT_STORAGE.setItem(STORE_ISFORCE_TO_SIGN_OUT, false);
            }

            const redirected = await this.HandleDaitonnPosQrRedirect(
              csp.toUpperCase(),
            );
            if (!redirected) {
              setTimeout(() => {
                if (csp.toUpperCase() === "AV") {
                  this.props.navigate(PT_LAND);
                } else {
                  this.props.navigate(PT_HOME);
                }
              }, 500);
            }
          }
        }
      }
      this.LoadDivisions();
    } catch (s) {
      console.error(s);
      await this.showStartupError(
        "Unable to start the app. Please refresh and try again.",
      );
    }
  }

  async HandleDaitonnPosQrRedirect(csp) {
    if (csp !== "DT") {
      ENCRYPT_STORAGE.removeItem(STORE_INVALID_QR);
      return false;
    }

    let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (entryMode !== "QR") {
      ENCRYPT_STORAGE.removeItem(STORE_INVALID_QR);
      return false;
    }

    await this.RunHomeDataSetupForPosQr();

    let mid = ENCRYPT_STORAGE.getItem(MID);
    let secretKey = ENCRYPT_STORAGE.getItem(SECRET_KEY);
    if (secretKey !== "abc1234" || mid === undefined) {
      ENCRYPT_STORAGE.removeItem(STORE_INVALID_QR);
      ENCRYPT_STORAGE.removeItem(SECRET_KEY);
      ENCRYPT_STORAGE.removeItem(ENTRY_MODE);
      ENCRYPT_STORAGE.removeItem("FROM");
      ENCRYPT_STORAGE.removeItem(MID);
      ENCRYPT_STORAGE.removeItem(TABLE_NO);
      return false;
    }

    dto_Merchant.MID = mid;
    try {
      const data = await api_LoadMerchantForMID(4, mid, true);
      if (data === undefined || data === null || String(data).trim() === "") {
        const merchantLoadError = new Error("Merchant response was empty");
        merchantLoadError.isMerchantStartupLoadFailed = true;
        throw merchantLoadError;
      }
      const objData = JSON.parse(data);
      if (this.isInvalidQrMerchantResponse(objData)) {
        ENCRYPT_STORAGE.setItem(STORE_INVALID_QR, true);
      } else {
        ENCRYPT_STORAGE.removeItem(STORE_INVALID_QR);
      }
      const merchantInfo = JSON.parse(objData.MerchantInfo);
      if (Array.isArray(merchantInfo) && merchantInfo.length > 0) {
        await set_dto_Merchant(merchantInfo[0]);
      }
    } catch (error) {
      ENCRYPT_STORAGE.removeItem(STORE_INVALID_QR);
      console.error("Startup POS/QR merchant load failed:", error);
      await this.showStartupError(
        "Unable to load merchant details right now. Please scan again or try later.",
        { showOverlay: true },
      );
      return true;
    }

    this.props.navigate(`/product-list/none/MID=${mid}`);
    return true;
  }

  async RunHomeDataSetupForPosQr() {
    await GET_SET_STORED_DATA();
    if (dto_common.CSP !== "AV") {
      if (dto_common.ZoneId === 0) {
        dto_common.ZoneId = 1;
        dto_common.ZoneDescription = "Dehiwala";
      }
      SET_ZONE_DESCRIPTION_HOME_SCREEN(dto_common.ZoneDescription);
    } else {
      SET_ZONE_DESCRIPTION_HOME_SCREEN(dto_common.ZoneDescription);
    }
  }

  async LoadDivisions() {
    let data = await api_LoadDevisons();
    let x = JSON.parse(data);
    ENCRYPT_STORAGE.setItem(STORE_Division_details, x);
  }

  render() {
    return (
      <>
        {this.RenderCspImages()}
        {this.renderBuildVersion()}
        {this.renderStartupError()}
      </>
    );
  }

  renderBuildVersion() {
    return (
      <div
        style={{
          position: "fixed",
          top: 10,
          right: 12,
          zIndex: 10,
          padding: "4px 8px",
          borderRadius: 12,
          backgroundColor: "rgba(0, 0, 0, 0.45)",
          color: "white",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.02em",
        }}
      >
        {BuildVersion}
      </div>
    );
  }

  renderStartupError() {
    if (!this.state.startupErrorMessage || !this.state.showQrStartupError) {
      return null;
    }

    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 20,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: isMobile ? "88px 24px 24px" : "72px 24px 24px",
          backgroundColor: "rgba(0, 0, 0, 0.35)",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 360,
            backgroundColor: "white",
            borderRadius: 16,
            padding: "20px 18px",
            textAlign: "center",
            boxShadow: "0 18px 40px rgba(0, 0, 0, 0.24)",
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              marginBottom: 8,
            }}
          >
            Unable to continue
          </div>
          <div
            style={{
              fontSize: 14,
              lineHeight: 1.45,
              color: "#333",
            }}
          >
            {this.state.startupErrorMessage}
          </div>
        </div>
      </div>
    );
  }

  RenderCspImages() {
    if (this.state.CSP === "AV") {
      return (
        <img
          src={require("../home/images/pg-startup/av-splash.gif")}
          width={"100%"}
          alt=""
        />
      );
    } else if (this.state.CSP === "MK") {
      return (
        <img
          src={require("../home/images/pg-startup/mk-splash.png")}
          width={"100%"}
          alt=""
        />
      );
    } else if (this.state.CSP === "DT") {
      return (
        <img
          src={require("../home/images/pg-startup/dt-splash.png")}
          width={"100%"}
          alt=""
        />
      );
    } else {
      return null;
    }
  }
}
